module.exports = __webpack_public_path__ + "img/20220202_075936.27aeef74.jpg";